import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const WebApp: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 17.22V22M2 13H22M7.5 22H16.5M6.44 2H17.55C21.11 2 22 2.89 22 6.44V12.77C22 16.33 21.11 17.21 17.56 17.21H6.44C2.89 17.22 2 16.33 2 12.78V6.44C2 2.89 2.89 2 6.44 2Z"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default WebApp;
